import Head from 'next/head';
import { useRouter } from 'next/router';

const CrHead = ({ pageTitle, pageDescription, children }) => {
  const router = useRouter();
  return (
    <Head>
      <title>
        {pageTitle
          ? pageTitle.length >= 50
            ? pageTitle.substring(0, 47) + '...'
            : pageTitle + ' | '
          : ''}
        Entry Level Jobs | Internships for Students | College Recruiter
      </title>
      <meta name="title" content={pageTitle} />
      <meta
        name="description"
        content={
          pageDescription
            ? pageDescription
            : 'Leading niche job board for college and university students searching for internships, part-time employment, and seasonal work and recent graduates hunting for entry-level jobs and other career opportunities.'
        }
        key="description"
      />
      <meta property="og:url" content={'https://www.collegerecruiter.com' + router.asPath} />
      <meta property="og:title" content={pageTitle} />
      <meta
        property="og:description"
        content={
          pageDescription
            ? pageDescription
            : 'Leading niche job board for college and university students searching for internships, part-time employment, and seasonal work and recent graduates hunting for entry-level jobs and other career opportunities.'
        }
        key="ogDescription"
      />
      <meta charSet="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, shrink-to-fit=no, viewport-fit=cover"
      />
      <meta name="author" content="College Recruiter" key="author" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <meta name="msapplication-TileColor" content="#8b0b04" />
      <meta name="msapplication-config" content="/favicons/browserconfig.xml" />
      <meta name="theme-color" content="#ffffff" />

      <link rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png" />
      <link rel="manifest" href="/favicons/site.webmanifest" />
      <link rel="mask-icon" href="/favicons/safari-pinned-tab.svg" color="#8a181a" />
      <link rel="shortcut icon" href="/favicons/favicon.ico"></link>

      {children}
    </Head>
  );
};

module.exports = CrHead;
